import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";
import PropTypes from 'prop-types';

import SidebarItem from "../../SidebarItem";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../SidebarContext";

RetailerProductListItem.propTypes = {
    retailerId: PropTypes.string.isRequired
};

function RetailerProductListItem({retailerId}) {
    const {currentPath, currentMemberAuthorizations} = useContext(SidebarContext);

    if(!hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_PRODUCT_VIEW)
        && !hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_PRODUCT_MANAGEMENT)
    )  {
        return null
    }

    return (
        <SidebarItem
            to={MarketplaceRoutes.RETAILER_PRODUCTS_LIST(retailerId)}
            selected={currentPath.includes(MarketplaceRoutes.RETAILER_PRODUCTS(retailerId))}
        >
            <FormattedMessage id='sidebar.item.productList' />
        </SidebarItem>
    );
}

export default RetailerProductListItem;
